"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@lingui/core");

var _blocks = require("@bueno/blocks");

var _columns = require("../../../utils/columns");

var _SortArrow = _interopRequireDefault(require("../../SortArrow"));

var _utils = require("../../../redux/modules/insights/utils");

var _Equip = require("./Equip.styles");

class EquipHeader extends _react.PureComponent {
  render() {
    const {
      isAllSelected,
      onSelectAll,
      hits,
      activeSort,
      sortDirection,
      onSort,
      isAllSelectedDisabled,
      children
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeader, {
      cursor: "pointer"
    }, /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, null, /*#__PURE__*/_react.default.createElement(_Equip.Color, null, /*#__PURE__*/_react.default.createElement(_blocks.Checkbox, {
      disabled: isAllSelectedDisabled,
      checked: isAllSelected,
      onChange: onSelectAll,
      "data-cy": "selectAllHits",
      small: true
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: _columns.equipColumns.LATEST.width,
      onClick: onSort(_columns.equipColumns.LATEST.key, _columns.equipColumns.LATEST.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.LATEST.label(_core.i18n), activeSort === _columns.equipColumns.LATEST.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: _columns.equipColumns.EQUIP_NAME.width,
      maxWidth: "200px",
      onClick: onSort(_columns.equipColumns.EQUIP_NAME.key, _columns.equipColumns.EQUIP_NAME.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.EQUIP_NAME.label(_core.i18n), activeSort === _columns.equipColumns.EQUIP_NAME.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: _columns.equipColumns.TRIGGERED_RULES.width,
      onClick: onSort(_columns.equipColumns.TRIGGERED_RULES.key, _columns.equipColumns.TRIGGERED_RULES.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.TRIGGERED_RULES.label(_core.i18n), activeSort === _columns.equipColumns.TRIGGERED_RULES.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: _columns.equipColumns.EQUIP_DETAILS.width,
      onClick: onSort(_columns.equipColumns.EQUIP_DETAILS.key, _columns.equipColumns.EQUIP_DETAILS.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.EQUIP_DETAILS.label(_core.i18n), activeSort === _columns.equipColumns.EQUIP_DETAILS.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: _columns.equipColumns.RULE_TYPE.width,
      onClick: onSort(_columns.equipColumns.RULE_TYPE.key, _columns.equipColumns.RULE_TYPE.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.RULE_TYPE.label(_core.i18n), activeSort === _columns.equipColumns.RULE_TYPE.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: "120px",
      onClick: onSort(_columns.equipColumns.ACTIONS_COUNT.key, _columns.equipColumns.ACTIONS_COUNT.sortDirection)
    }, /*#__PURE__*/_react.default.createElement(_blocks.Main, null, _columns.equipColumns.ACTIONS_COUNT.label(_core.i18n), ' ', /*#__PURE__*/_react.default.createElement(_blocks.Badge, null, (0, _utils.getUniqIssues)(hits).length), activeSort === _columns.equipColumns.ACTIONS_COUNT.key && /*#__PURE__*/_react.default.createElement(_SortArrow.default, {
      direction: sortDirection
    }))), /*#__PURE__*/_react.default.createElement(_blocks.DataGridHeading, {
      minWidth: "132px"
    }), children);
  }

}

var _default = EquipHeader;
exports.default = _default;
module.exports = exports.default;